(function() {
  "use strict";
  const f = (r) => new Promise((e) => {
    const t = document.querySelector(r);
    t && e(t);
    const o = new MutationObserver(() => {
      const a = document.querySelector(r);
      a && (e(a), o.disconnect());
    });
    o.observe(document.documentElement, {
      childList: !0,
      subtree: !0
    });
  }), u = async (r) => {
    const e = (t) => new Promise((o, a) => {
      const p = t.split(".").pop();
      if (p === "js") {
        if (Array.from(document.scripts).map(
          (i) => i.src.toLowerCase()
        ).includes(t.toLowerCase()))
          return n(`Script ${t} allready downloaded!`, "success"), o("");
        const s = document.createElement("script");
        s.src = t, s.onload = o, s.onerror = a, s.async = !0, document.head.appendChild(s);
      } else if (p === "css") {
        if (Array.from(document.styleSheets).map(
          (i) => {
            var d;
            return (d = i.href) == null ? void 0 : d.toLowerCase();
          }
        ).includes(t.toLowerCase()))
          return n(`Style ${t} allready downloaded!`, "success"), o("");
        const s = document.createElement("link");
        s.rel = "stylesheet", s.href = t, s.onload = o, s.onerror = a, document.head.appendChild(s);
      }
    });
    for (const t of r)
      n(t), await e(t), n(`Loaded librari ${t}`);
    n("All libraries loaded!", "success");
  }, n = (r, e = "info") => {
    let t;
    switch (e) {
      case "info":
        t = "color: #3498db;";
        break;
      case "warn":
        t = "color: #f39c12;";
        break;
      case "error":
        t = "color: #e74c3c;";
        break;
      case "success":
        t = "color: #2ecc71;";
        break;
    }
    console.log(`%c>>> ${r}`, `${t} font-size: 16px; font-weight: 600`);
  }, v = (r) => ({
    scriptUrl: `https://app.thefrontrowhealth.com/api/widgets/script?presentation_type=qual&product_id=${r}`,
    frame: `
      <iframe
        id="frontrow-testimonials"
        class="iframe-frontrow-testimonials"
        frameborder="0"
        src="https://app.thefrontrowhealth.com/api/widgets?presentation_type=qual&product_id=${r}"
      ></iframe>
    `
  }), x = {
    "/products/allergypatch-allergy-relief-stickers": 2122, 
    "/products/sunnypatch": 2125,
    "/pages/sunnypatch": 2125,
    "/products/pack-magic-patch-bundles": 2123,
    "/pages/magicpatch": 2123,
    "/products/focuspatch-focus-enhancing-stickers": 2090,
    "/pages/focuspatch": 2090,
    "/products/buzzpatch-bundles": 2119,
    "/pages/buzzpatch": 2119,
    "/pages/mosquito-kit": 2119,
    "/pages/mosquito-kit-2": 2119,
    "/products/stuffypatch": 2121,
    "/pages/stuffypatch": 2121,
    "/products/sleepypatch-sleep-promoting-stickers": 2088,
    "/pages/sleepypatch": 2088,
    "/products/zenpatch-mood-calming-stickers": 2089,
    "/pages/zenpatch": 2089
  }, l = Object.fromEntries(
    Object.entries(x).map(([r, e]) => [r, v(e)])
  ), _ = `
    .fr-testimonials--page {
      position: relative;
      z-index: 1;
    }
    .fr-testimonials--page iframe.iframe-modal-testimonials {
      position: fixed !important;
      top: 0 !important;
      left: 0 !important;
      z-index: 99999999 !important;
    }
    #frontrow-sticker {
      position: absolute;
      top: 20px;
      z-index: 3;
      border-radius: 0 !important;
    }
    .iframe.frontrow {
      display: none;
      position: fixed;
      left: 0;
      top: 0;
      z-index: 99999997;
      right: 0;
      bottom: 0;
      width: 100%;
      height: 100%;
      overflow: hidden;
    }
  `;
  const g = (r) => r in l;
  const getPathWithoutLocale = (pathname) => {
    // Remove locale prefix like /en-au, /en-ph, /en-uk, etc.
    const parts = pathname.split('/').filter(Boolean);
    if (parts.length > 0 && /^[a-z]{2}(-[a-z]{2})?$/.test(parts[0])) {
      return '/' + parts.slice(1).join('/');
    }
    return pathname;
  };
  class b {
    constructor() {
      this.init();
    }
    init() {
      if (document.querySelector("#frontrow-testimonials")) {
        n("Frontrow testimonials already present, skipping inject", "success");
        return;
      }
      const pathWithoutLocale = getPathWithoutLocale(location.pathname);
      g(pathWithoutLocale) && (this.injectFrame(pathWithoutLocale), this.addStyles());
    }
    async injectFrame(pathname) {
      const o = pathname;
      const isPage = o.startsWith("/pages/");
      
      n(`Current pathname: ${o}`, "info");
      n(`Is page: ${isPage}`, "info");

      if (document.querySelector("#frontrow-testimonials")) {
        n("Frontrow testimonials already present, skipping inject", "success");
        return;
      }
      
      let t;
      if (isPage) {
        n("Looking for #reviews section...", "info");
        t = await f("#reviews");
        n(t ? "Found #reviews" : "#reviews not found", t ? "success" : "error");
        if (!t) return;
      } else {
        n("Looking for #judgeme_product_reviews...", "info");
        const e = await f("#judgeme_product_reviews");
        if (!e) return;
        t = e.closest("section");
        if (!t) return;
      }
      
      const a = l[o];
      n("Injecting clinician reviews...", "info");
      await u([a.scriptUrl + ".js"]);
      
      const sectionClass = isPage ? "fr-testimonials fr-testimonials--page" : "fr-testimonials";
      
      t.insertAdjacentHTML(
        "beforebegin",
        /* HTML */
        `<section class="${sectionClass}">
        <style>
          iframe.iframe-frontrow-testimonials {
            width: 100%;
          }
          iframe.iframe-modal-testimonials {
            z-index: 99999998;
          }
        </style>
        <div class="page-width">${a.frame}</div>
      </section>`
      );
    }
    addStyles() {
      const e = document.createElement("style");
      e.textContent = _, document.head.appendChild(e);
    }
  }
  new b();
})();